import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { Customer } from '@features/customer/models/customer';
import { PnycIconComponent } from '@ui-kit/pnyc-icon/pnyc-icon.component';

type CustomerAvatarStatus = 'hot-prospect' | 'active' | 'inactive';

@Component({
    selector: 'customer-avatar-status',
    templateUrl: './customer-avatar-status.component.html',
    styleUrl: './customer-avatar-status.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PnycIconComponent],
})
export class CustomerAvatarStatusComponent {
    readonly customer = input.required<Customer>();

    readonly status = computed<CustomerAvatarStatus>(() => {
        const customer = this.customer();

        if (customer.isHotProspect) {
            return 'hot-prospect';
        }

        return customer.status === 'ACTIVE' ? 'active' : 'inactive';
    });
}
